module.exports = __webpack_public_path__ + "static/media/iCiel Gotham-Medium.022af2f6.ttf";